/**
 * Created by lari on 08/06/2017.
 */

/* either pass list of users (patients) to display or load users */


(function () {
  'use strict';
  angular.module('vcuser.vcuser')
    .component('userlist', {
      restrict: 'E',
      bindings: {
        users: '<?',
        roles: '<'
      },
      template: `
        <table class="table table-striped">
          <thead>
          <tr>
            <th>Username</th>
            <th>Vor- und Nachname</th>
            <th>E-Mail</th>
            <th>Telefonnummer</th>
            <th>Rolle</th>
            <th>Aktion</th>
          </tr>
          </thead>
          <tr ng-repeat="user in vm.users">
            <td>{{user.username}}</td>
            <td>{{user.realName}}</td>
            <td>{{user.email}}</td>
            <td>{{user.tel}}</td>
            <td ng-bind="vm.getRoleLabel(user)"></td>
            <td>
              <button class="btn btn-primary" ng-click="vm.editUser(user, vm.roles)" uib-tooltip="Editieren"><i class="fa fa-edit"></i></button>
              <button class="btn btn-danger" ng-click="vm.removeUser(user)" uib-tooltip="Löschen"><i class="fa fa-remove"></i></button>
            </td>
          </tr>
        </table>
      `,
      controllerAs: 'vm',
      controller: ['$log', '$http', 'Rlog', 'User', 'UserHelper', 'vertxEventBusService',
        function ($log, $http, Rlog, User, UserHelper, vertxEventBusService) {
          let vm = this;
          vm.editUser = UserHelper.editUser;
          vm.removeUser = removeUser;
          vm.getRoleLabel = getRoleLabel;

          vm.$onInit = function () {
            if (angular.isUndefined(vm.roles) || !angular.isArray(vm.roles) || vm.roles.length === 0) {
              vm.roles = [{role: 'admin', label: 'Administrator'}, {role: 'user', label: 'Anwender'}];
            }
            // unless users list has been passed for test purposes, retrieve vcclient list from web
            if (angular.isUndefined(vm.users)) {
              vm.users = User.$search({active: true});
            }
          }; // $onInit()


          function removeUser(user) {
            user.active = false;
            user.$save();
          }

          function getRoleLabel(user) {
            if (angular.isDefined(vm.roles)) {
              for (let i = 0; i < vm.roles.length; i++) {
                if (vm.roles[i].role === user.roles[0]) {
                  return vm.roles[i].label;
                }
              }
            }
          }

          vertxEventBusService.on('users.update', function (message) {
            $log.debug('debug: user update received: ', message);
            // let messages = message.split(':');
            vm.users.$refresh().$then(function () {
              $log.debug('debug: userlist refreshed users');
            }, function (error) {
              $log.debug('debug: userlist refresh users failed: ', error);
            });
          });


        }] // controller
    }); // component

  // klammerfriedhof
}());